/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const AclLevel = {
  NONE: 'NONE',
  BROWSE: 'BROWSE',
  VIEW: 'VIEW',
  READ: 'READ',
  WRITE: 'WRITE',
  DELETE: 'DELETE'
} as const

export const FsiType = {
  FOLDER: 'FOLDER',
  DOCUMENT: 'DOCUMENT',
  REFERENCE: 'REFERENCE',
  PLACEHOLDER: 'PLACEHOLDER'
} as const

export const SystemFolderType = {
  WORKFLOWS: 'WORKFLOWS',
  REGULATED_CONTENT: 'REGULATED_CONTENT',
  TEMPLATES: 'TEMPLATES',
  FORMS: 'FORMS',
  CONTAMINATED: 'CONTAMINATED',
  UPLOAD: 'UPLOAD',
  REPORTS: 'REPORTS',
  SYSTEM_DOCUMENTS: 'SYSTEM_DOCUMENTS',
  EMAIL_UPLOADS: 'EMAIL_UPLOADS',
  INIT_ETMF_FILES: 'INIT_ETMF_FILES',
  DOCUMENT_MIGRATIONS_AND_EXPORTS: 'DOCUMENT_MIGRATIONS_AND_EXPORTS',
  SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS: 'SETTINGS_AND_SYSTEM_EXPORTS_IMPORTS'
} as const

export const FsiLifecycleState = {
  APPROVED: 'APPROVED',
  DRAFT: 'DRAFT',
  EFFECTIVE: 'EFFECTIVE',
  HELPER_EXPIRING: 'HELPER_EXPIRING',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  OBSOLETE: 'OBSOLETE',
  REJECTED: 'REJECTED',
  RETIRED: 'RETIRED'
} as const

export const ReferenceType = {
  DOCUMENT: 'DOCUMENT',
  FORM: 'FORM',
  AMENDMENT: 'AMENDMENT'
} as const

export type AclLevelType = (typeof AclLevel)[keyof typeof AclLevel]
export type FsiTypeType = (typeof FsiType)[keyof typeof FsiType]
export type SystemFolderTypeType = (typeof SystemFolderType)[keyof typeof SystemFolderType]
export type FsiLifecycleStateType = (typeof FsiLifecycleState)[keyof typeof FsiLifecycleState]
export type ReferenceTypeType = (typeof ReferenceType)[keyof typeof ReferenceType]
